import axios from 'axios';
import { documentsConstants } from '../../constants/documents.constants';
import { authHeader } from '../../../../helpers/auth-header';
import { client } from '../../../../actions';
import { documentListConstants } from '../../constants/document-list.constants';
import moment from 'moment';
import { removeSelectionFromDefaultFilter } from './documentFilter/documentFilterActions';
import { fromDateStr, toDateStr } from '../../../../helpers/utcDate';
//import {
//	setChosenDocumentsFilter,
//	setChosenDocumentsFilterName,
//} from './documentFilter/documentFilterActions';

const url = '/docs';
let dspxFilterTimer;
let cancelFetchDocuments;

export const documentsActions = {
  fetchDocuments,
  closeFilter,
  closeReport,
  searchDocuments,
  fetchReports,
  fetchCompanies,
  fetchWorkers,
  //fetchExecuters,
  fetchStatuses,
  //fetchTypes,
  setDateRange,
  setSelectedDateRange,
  setAddrFlatValue,
  setDateRangeField,
  setReport,
  //downloadReport,
  applyCompany,
  applyServiceCompany,
  applyWorker,
  applyExecuter,
  applyCreator,
  applyResponsible,
  applyStatus,
  applyType,
  applySubType,
  applyService,
  applySubservice,
  applyAddrStreet,
  applyAddrBuilding,
  applyPhone,
  applyRating,
  applyWarranty,
  applyNotWarranty,
  applyPossWarranty,
  applyRetry,
  applyBadWork,
  applyChargeable,
  applyImmediate,
  resetFilter,
  getDocumentByNumber,
  setViewOtherDocs,
  setExpiredModeValue,
  setFilterNewVisible,
  fetchRequestsTimer,
  setRelatedDocsModal,
};

function resetFilter() {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.RESET_FILTER,
    });
    //fetchRequestsTimer(dispatch);
    cancelFetchDocuments();
    dispatch(removeSelectionFromDefaultFilter());
    dispatch(fetchDocuments());
  };
}

function fetchRequestsTimer(dispatch) {
  dspxFilterTimer && clearTimeout(dspxFilterTimer);
  cancelFetchDocuments && cancelFetchDocuments();
  dspxFilterTimer = setTimeout(() => {
    dispatch(fetchDocuments());
  }, 1100);
}

function fetchDocuments(number, forReport) {
  return (dispatch, getState) => {
    const {
      report,
      reports,
      warranty,
      notWarranty,
      possWarranty,
      search,
      expiredMode,
    } = getState().documentsStore;

    const { postDocumentID } = getState().newDocumentStore;

    const {
      dateRangeField,
      dateRange,
      companyId,
      typeId,
      streetId,
      houseId,
      flatIds,
      statuses,
      responsibleWorkerId,
      executerId,
      orgsIds,
      creatorIds,
      subtypes,
      topic,
      sourceNumber,
      sourceDate,
      deadlineDate,
      viewOtherDocsSelected,
      topicIds,
      sourceId,
    } = getState().documentFilterNewStore;

    const warranties = [];
    notWarranty && warranties.push(0);
    warranty && warranties.push(1);
    possWarranty && warranties.push(2);

    let rurl = forReport ? '' : url + (expiredMode ? '/expired' : '');

    if (number) {
      rurl += '?documentId=' + number;
    } else if (search) {
      rurl += '?documentNumber=' + search;
    } else {
      if (dateRangeField === 'create_time') {
        rurl +=
          '?fromDate=' +
          fromDateStr(dateRange[0]) +
          '&toDate=' +
          toDateStr(dateRange[1]);
      } else if (dateRangeField === 'register_date') {
        rurl +=
          '?registrationFromDate=' +
          fromDateStr(dateRange[0]) +
          '&registrationToDate=' +
          toDateStr(dateRange[1]);
      } else if (dateRangeField === 'execution_date') {
        rurl +=
          '?doneDateFrom=' +
          fromDateStr(dateRange[0]) +
          '&doneDateTo=' +
          toDateStr(dateRange[1]);
      }
    }

    if (companyId) {
      rurl += '&serviceCompanyId=' + companyId;
    }
    if (executerId) rurl += '&appointedWorkerId=' + executerId;
    if (responsibleWorkerId)
      rurl += '&responsibleWorkerId=' + responsibleWorkerId;
    if (creatorIds && creatorIds.length > 0) {
      creatorIds.forEach((creatorId) => {
        rurl += '&creatorIds=' + creatorId;
      });
    }
    if (orgsIds && orgsIds.length > 0) {
      orgsIds.forEach((orgsId) => {
        rurl += '&orgs=' + orgsId;
      });
    }
    if (streetId) rurl += '&streets=' + [streetId];
    if (houseId) rurl += '&houses=' + [houseId];
    if (flatIds && flatIds.length > 0) {
      flatIds.forEach((flatId) => {
        rurl += '&addresses=' + flatId;
      });
    }
    if (statuses && statuses.length > 0) {
      statuses.forEach((status) => {
        rurl += '&statuses=' + status;
      });
    }
    if (topicIds && topicIds.length > 0) {
      topicIds.forEach((topicId) => {
        rurl += '&topicIds=' + topicId;
      });
    }
    if (typeId) rurl += '&types=' + [typeId];
    if (subtypes && subtypes.length > 0) {
      subtypes.forEach((subtype) => {
        rurl += '&subtypes=' + subtype;
      });
    }
    if (topic) rurl += '&topic=' + topic;
    if (sourceId) rurl += '&sourceId=' + sourceId;
    if (sourceNumber) rurl += '&sourceNumber=' + sourceNumber;
    rurl += '&viewOtherDocsSelected=' + viewOtherDocsSelected;

    if (!!sourceDate)
      rurl +=
        '&inDateFrom=' +
        fromDateStr(sourceDate[0]) +
        '&inDateTo=' +
        toDateStr(sourceDate[1]);

    if (!!deadlineDate)
      rurl +=
        '&deadlineDateFrom=' +
        fromDateStr(deadlineDate[0]) +
        '&deadlineDateTo=' +
        toDateStr(deadlineDate[1]);

    if (forReport) {
      report &&
        report.forEach((el) => {
          const r = reports.find((rel) => rel.id == el);
          const u = r.url + !!postDocumentID ? url : rurl;

          client.get(u, { headers: authHeader() }).then((response) => {
            let data = Buffer.from(response.data, 'base64');
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', r.name + '.xml');
            document.body.appendChild(link);
            link.click();
          });
        });
    } else {
      let CancelToken = axios.CancelToken;
      dispatch({
        type: documentsConstants.FETCH_DOCUMENTS,
        payload: client
          .get(!!postDocumentID ? url : rurl, {
            headers: authHeader(),
            cancelToken: new CancelToken(function executor(c) {
              cancelFetchDocuments = c;
            }),
          })
          .catch((error) => {
            if (axios.isCancel(error)) {
              console.log('Documents fetch canceled', error.message);
            }
          }),
      });
      dispatch({
        type: documentListConstants.SET_SELECTED_ROWS,
        payload: [],
      });
      dispatch({
        type: documentsConstants.SET_EXPIRED_MODE_QUERY,
        payload: !!postDocumentID ? url : rurl,
      });
    }
  };
}

function fetchReports() {
  let rurl = '/report/awailable';

  return (dispatch) => {
    dispatch({
      type: documentsConstants.SET_REPORTS,
      payload: client.get(rurl, { headers: authHeader() }),
    });

    dispatch(setReport(['1']));
  };
}

function fetchCompanies() {
  let rurl = url + '/companies';

  return (dispatch) => {
    dispatch({
      type: documentsConstants.SET_FILTER_COMPANY,
      payload: client.get(rurl, { headers: authHeader() }),
    });
  };
}

function fetchDistricts() {
  let rurl = url + '/city_regions';

  return (dispatch) => {
    //const d = [{id: 28, name: 'Юбилейный'},{id: 29, name: 'Центральный'}]
    dispatch({
      type: documentsConstants.SET_FILTER_DISTRICT,
      //payload:  new Promise((resolve=>resolve({data: d})))  //client.get(rurl, { headers: authHeader() })
      payload: client.get(rurl, { headers: authHeader() }),
    });
  };
}

function fetchWorkers(opt) {
  // eslint-disable-next-line
  const { dateRange, dateRangeField } = opt;
  let rurl = url + '/workers';

  return (dispatch) => {
    dispatch({
      type: documentsConstants.SET_FILTER_WORKER,
      payload: client.get(rurl, { headers: authHeader() }),
    });
  };
}

/*function fetchExecuters(opt) {
	// eslint-disable-next-line
	const { dateRange, dateRangeField } = opt;
	let rurl = url + '/executers';

	return dispatch => {
		dispatch({
			type: documentsConstants.SET_FILTER_EXECUTER,
			payload: client.get(rurl, { headers: authHeader() })
		})
	}
}*/

function fetchStatuses() {
  let rurl = url + '/statuses';
  return (dispatch) => {
    dispatch({
      type: documentsConstants.SET_FILTER_STATUS,
      payload: client.get(rurl, { headers: authHeader() }),
    });
  };
}

/*function fetchTypes() {
	let rurl = url + '/types';
	return dispatch => {
		dispatch({
			type: documentsConstants.SET_FILTER_TYPE,
			payload: client.get(rurl, { headers: authHeader() })
		})
	}
}*/

function closeFilter(visible) {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.CLOSE_FILTER,
      payload: visible,
    });
  };
}

function setFilterNewVisible(visible) {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.SET_FILTER_NEW_VISIBLE,
      payload: visible,
    });
  };
}

function closeReport(visible) {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.CLOSE_REPORT,
      payload: visible,
    });
  };
}

function setReport(filter) {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.SET_REPORT,
      payload: filter,
    });
  };
}

function applyCompany(filter) {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.APPLY_COMPANY,
      payload: filter,
    });
    dispatch(removeSelectionFromDefaultFilter());
    fetchRequestsTimer(dispatch);
  };
}

function applyServiceCompany(filter) {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.APPLY_SERVICE_COMPANY,
      payload: filter,
    });
    dispatch(removeSelectionFromDefaultFilter());
    fetchRequestsTimer(dispatch);
  };
}

function applyWorker(filter) {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.APPLY_WORKER,
      payload: filter,
    });

    fetchRequestsTimer(dispatch);
  };
}

function applyExecuter(filter) {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.APPLY_EXECUTER,
      payload: filter,
    });
    dispatch(removeSelectionFromDefaultFilter());
    fetchRequestsTimer(dispatch);
  };
}

function applyCreator(filter) {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.APPLY_CREATOR,
      payload: filter,
    });
    dispatch(removeSelectionFromDefaultFilter());
    fetchRequestsTimer(dispatch);
  };
}

function applyWarranty(filter) {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.APPLY_WARRANTY,
      payload: filter,
    });

    fetchRequestsTimer(dispatch);
  };
}

function applyNotWarranty(filter) {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.APPLY_NOT_WARRANTY,
      payload: filter,
    });

    fetchRequestsTimer(dispatch);
  };
}

function applyPossWarranty(filter) {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.APPLY_POSS_WARRANTY,
      payload: filter,
    });

    fetchRequestsTimer(dispatch);
  };
}

function applyRetry(filter) {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.APPLY_RETRY,
      payload: filter,
    });

    fetchRequestsTimer(dispatch);
  };
}

function applyChargeable(filter) {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.APPLY_CHARGEABLE,
      payload: filter,
    });

    fetchRequestsTimer(dispatch);
  };
}

function applyImmediate(filter) {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.APPLY_IMMEDIATE,
      payload: filter,
    });

    fetchRequestsTimer(dispatch);
  };
}

function applyResponsible(filter) {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.APPLY_RESPONSIBLE_WORKER,
      payload: filter,
    });
    dispatch(removeSelectionFromDefaultFilter);
    fetchRequestsTimer(dispatch);
  };
}

function applyBadWork(filter) {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.APPLY_BADWORK,
      payload: filter,
    });

    fetchRequestsTimer(dispatch);
  };
}

function applyStatus(filter) {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.APPLY_STATUS,
      payload: filter,
    });
    dispatch(removeSelectionFromDefaultFilter());
    fetchRequestsTimer(dispatch);
  };
}

function applyType(filter) {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.APPLY_TYPE,
      payload: filter,
    });
    dispatch(removeSelectionFromDefaultFilter());
    fetchRequestsTimer(dispatch);
  };
}

function applySubType(filter) {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.APPLY_SUBTYPE,
      payload: filter,
    });
    dispatch(removeSelectionFromDefaultFilter());
    fetchRequestsTimer(dispatch);
  };
}

function setSubserviceValue(value) {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.SET_SUBSERVICE_VALUE,
      payload: value,
    });

    fetchRequestsTimer(dispatch);
  };
}

function fetchSubserviceList(service) {
  let rurl = url + '/services?parentIds=' + service;

  return (dispatch) => {
    dispatch({
      type: documentsConstants.FETCH_SUBSERVICE,
      payload: client.get(rurl, { headers: authHeader() }),
    });
  };
}

function applyService(value, opt) {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.APPLY_SERVICE,
      payload: value,
    });

    dispatch(fetchSubserviceList(value));
    dispatch(setSubserviceValue(undefined));
  };
}

function setAddrBuildingValue(value) {
  return (dispatch, getState) => {
    dispatch({
      type: documentsConstants.SET_ADDR_BUILDING_VALUE,
      payload: value,
    });

    fetchRequestsTimer(dispatch);
  };
}

function setAddrFlatValue(value) {
  return (dispatch, getState) => {
    dispatch({
      type: documentsConstants.SET_ADDR_FLAT_VALUE,
      payload: value,
    });
    dispatch(removeSelectionFromDefaultFilter());
    fetchRequestsTimer(dispatch);
  };
}

function setPhoneValue(value) {
  return (dispatch, getState) => {
    dispatch({
      type: documentsConstants.SET_PHONE_VALUE,
      payload: value,
    });

    fetchRequestsTimer(dispatch);
  };
}

function setRatingValue(value) {
  return (dispatch, getState) => {
    dispatch({
      type: documentsConstants.SET_RATING_VALUE,
      payload: value,
    });

    fetchRequestsTimer(dispatch);
  };
}

function fetchAddrBuildingList(street) {
  let rurl = '/Request/houses';
  if (street && street.length === 1 && !isNaN(street[0]))
    rurl += '/' + street[0];
  else
    return (dispatch) => {
      dispatch({
        type: documentsConstants.FETCH_ADDR_BUILDING,
        payload: new Promise((resolve, reject) => {
          resolve({ data: [] });
        }),
      });
    };

  return (dispatch) => {
    dispatch({
      type: documentsConstants.FETCH_ADDR_BUILDING,
      payload: client.get(rurl, { headers: authHeader() }),
    });
  };
}

function fetchAddrFlatList(building) {
  let rurl = '/Request/house_flats';
  if (building && building.length === 1 && !isNaN(building[0]))
    rurl += '/' + building;
  else
    return (dispatch) => {
      dispatch({
        type: documentsConstants.FETCH_ADDR_FLAT,
        payload: new Promise((resolve, reject) => {
          resolve({ data: [] });
        }),
      });
    };

  return (dispatch) => {
    dispatch({
      type: documentsConstants.FETCH_ADDR_FLAT,
      payload: client.get(rurl, { headers: authHeader() }),
    });
  };
}

function applyAddrBuilding(value) {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.SET_ADDR_BUILDING_VALUE,
      payload: value,
    });

    dispatch(fetchAddrFlatList(value));
    dispatch(setAddrFlatValue(undefined));
    dispatch(removeSelectionFromDefaultFilter());
  };
}

function applyAddrStreet(value) {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.APPLY_ADDR_STREET,
      payload: value,
    });

    dispatch(fetchAddrBuildingList(value));
    dispatch(setAddrBuildingValue(undefined));
    dispatch(fetchAddrFlatList(undefined));
    dispatch(setAddrFlatValue(undefined));
    dispatch(removeSelectionFromDefaultFilter());
  };
}

function applyPhone(value) {
  return (dispatch) => {
    dispatch(setPhoneValue(value));
  };
}

function applyRating(value) {
  return (dispatch) => {
    dispatch(setRatingValue(value));
  };
}

function applySubservice(value) {
  return (dispatch) => {
    dispatch(setSubserviceValue(value));
  };
}

function searchDocuments(search) {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.SET_DOCUMENT_SEARCH,
      payload: search.length > 0 ? search : undefined,
    });
    dispatch(fetchDocuments());
  };
}

function getDocumentByNumber(number) {
  return (dispatch) => {
    dispatch(fetchDocuments(number));
  };
}

function setDateRange(dateRange) {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.SET_DATE_RANGE,
      payload: dateRange,
    });

    fetchRequestsTimer(dispatch);
  };
}

function setSelectedDateRange(range) {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.SELECT_DATE_RANGE,
      payload: range,
    });
    dispatch(removeSelectionFromDefaultFilter());
  };
}

function setDateRangeField(rangeField) {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.SET_DATE_RANGE_FIELD,
      payload: rangeField,
    });
    dispatch(removeSelectionFromDefaultFilter());
    fetchRequestsTimer(dispatch);
  };
}

function setViewOtherDocs(boolValue) {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.SET_VIEW_OTHER_DOCS,
      payload: boolValue,
    });
    fetchRequestsTimer(dispatch);
  };
}

export function setDocumentFilterValues(filterValues) {
  return (dispatch) => {
    const { dateRange } = filterValues;
    const filter = {
      ...filterValues,
      dateRange: [moment(dateRange[0]), moment(dateRange[1])],
    };
    dispatch({
      type: documentsConstants.SET_DOCUMENT_FILTER_VALUES,
      payload: filter,
    });

    fetchRequestsTimer(dispatch);
  };
}

export function setExpiredModeValue(boolValue) {
  return (dispatch) => {
    dispatch({
      type: documentsConstants.SET_EXPIRED_MODE,
      payload: boolValue,
    });

    fetchRequestsTimer(dispatch);
  };
}

function setRelatedDocsModal(value) {
  return (dispatch, getState) => {
    dispatch({
      type: documentsConstants.SET_VISIBLE_RELATED_DOCS_MODAL,
      payload: value,
    });
  };
}
